import React from "react";
import { Label } from "../_internal/Label";
import { MultiSelectChip } from "../_internal/MultiSelectChip";
import { getOptionLabelDefault } from "../_internal/Option";
import { TypographyStack } from "../Typography";
import { cx } from "../../helpers/utils/cx";
export function ReadOnlySelect(_ref) {
  let {
    label,
    infoText,
    value = null,
    getValueFromOption,
    getOptionLabel = getOptionLabelDefault,
    helperText,
    required,
    fullWidth,
    rootClassName,
    multiple,
    size
  } = _ref;
  const singleValueRenderer = getValueFromOption || getOptionLabel;
  return /*#__PURE__*/React.createElement("div", {
    className: cx(rootClassName)
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("flex flex-col gap-2", fullWidth ? "w-full" : "w-96")
  }, label && /*#__PURE__*/React.createElement(Label, {
    text: label,
    infoText: infoText,
    required: required
  }), Array.isArray(value) || multiple ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cx("flex gap-1")
  }, Array.isArray(value) ? value.map(option => /*#__PURE__*/React.createElement(MultiSelectChip, {
    key: option.value,
    label: singleValueRenderer(option),
    size: size
  })) : null), helperText && /*#__PURE__*/React.createElement(TypographyStack, {
    secondary: helperText,
    variant: size === "sm" ? "sm" : "base"
  })) : /*#__PURE__*/React.createElement(TypographyStack, {
    primary: singleValueRenderer(value),
    secondary: helperText,
    variant: size === "sm" ? "sm" : "base"
  })));
}